import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Mail, Instagram, Send } from "lucide-react";
import { toast, Toaster } from "sonner";
import { api } from "@/lib/api";
import { BottomTab } from "@/components/BottomTab";

export default function Contatti() {
  const nav = useNavigate();
  const [event, setEvent] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get("/event").then((r) => setEvent(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Compila tutti i campi");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact-messages", form);
      toast.success("Messaggio inviato! Ti risponderemo presto.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Errore nell'invio. Riprova.");
    } finally {
      setSending(false);
    }
  };

  const email = event?.contact_email || "themadbar26@gmail.com";
  const ig = event?.contact_instagram || "the_mad_bar";

  return (
    <div className="min-h-screen pb-24 bg-surface" data-testid="contatti-page">
      <Toaster position="top-center" richColors />
      <header className="bg-black px-4 pb-5 flex items-center gap-3" style={{ paddingTop: "calc(var(--safe-top) + 16px)" }}>
        <button data-testid="contatti-back-btn" onClick={() => nav("/event")} className="text-white">
          <ChevronLeft size={32} strokeWidth={2.5} />
        </button>
        <h1 className="text-2xl font-black text-white">Contatti</h1>
      </header>

      <div className="px-4 pt-4 space-y-3">
        <a data-testid="contact-email" href={`mailto:${email}`} className="flex items-center gap-4 bg-surface2 rounded-2xl px-5 py-4">
          <div className="w-12 h-12 rounded-2xl bg-brand flex items-center justify-center"><Mail className="text-onbrand" /></div>
          <div className="min-w-0">
            <p className="text-sm text-onsurface3 font-bold">Email</p>
            <p className="font-black text-onsurface break-all">{email}</p>
          </div>
        </a>
        <a data-testid="contact-instagram" href={`https://instagram.com/${ig}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 bg-surface2 rounded-2xl px-5 py-4">
          <div className="w-12 h-12 rounded-2xl bg-black flex items-center justify-center"><Instagram className="text-white" /></div>
          <div className="min-w-0">
            <p className="text-sm text-onsurface3 font-bold">Instagram</p>
            <p className="font-black text-onsurface">@{ig}</p>
          </div>
        </a>
      </div>

      <form onSubmit={submit} className="px-4 pt-6" data-testid="contact-form">
        <h2 className="font-black text-lg text-onsurface mb-3">Scrivi allo staff</h2>
        <div className="space-y-3">
          <input
            data-testid="contact-name-input"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            placeholder="Nome"
            className="w-full bg-surface2 rounded-2xl px-5 py-4 font-bold text-onsurface outline-none focus:ring-2 ring-brand"
          />
          <input
            data-testid="contact-email-input"
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="La tua email"
            className="w-full bg-surface2 rounded-2xl px-5 py-4 font-bold text-onsurface outline-none focus:ring-2 ring-brand"
          />
          <textarea
            data-testid="contact-message-input"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            placeholder="Il tuo messaggio"
            rows={4}
            className="w-full bg-surface2 rounded-2xl px-5 py-4 font-bold text-onsurface outline-none focus:ring-2 ring-brand resize-none"
          />
          <button
            data-testid="contact-submit-btn"
            disabled={sending}
            className="w-full bg-brand text-onbrand rounded-2xl py-4 font-black text-lg flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {sending ? "Invio..." : <>Invia <Send size={20} /></>}
          </button>
        </div>
      </form>

      <BottomTab />
    </div>
  );
}
